(function (angular, app) {
	'use strict';

	app.service('AddressFormService', [
		'GOOGLE_MAP_ADDRESS_TYPES',
		'FILTER_ADDRESS_MODE',
		'SP_SERVICES',
		'GoogleMapService',
		'AddressService',
		'Config',
		'Util',
		'$filter',
		'$q',
		'$rootScope',
		function (GOOGLE_MAP_ADDRESS_TYPES, FILTER_ADDRESS_MODE, SP_SERVICES, GoogleMapService, AddressService, Config, Util, $filter, $q, $rootScope) {
			var addressFormService = this;
			var _translate = $filter('translate');
			var _addressVerificationText = Util.tryParseJson(Config.retailer.settings.addressVerificationText || '{}');
			var _addressVerificationTextDropPinOff = Util.tryParseJson(Config.retailer.settings.addressVerificationTextDroppinOff || '{}');
			var isGoogleMapDropPinAllow = Config.retailer.settings.isGoogleMapDropPinAllow === 'true';
			var isGoogleMapDropPinValidateHouseNumAndStreet = Config.retailer.settings.isGoogleMapDropPinValidateHouseNumAndStreet === 'true';

			var enableAddressFiltering = Config.retailer.settings.enableAddressFiltering === 'true';
			var addressFiltering = enableAddressFiltering ? Number(Config.retailer.settings.addressFiltering) : null;
			var isAddressFilteringCityMode = enableAddressFiltering && addressFiltering === FILTER_ADDRESS_MODE.CITY;
			var isAddressFilteringZipCodeMode = enableAddressFiltering && addressFiltering === FILTER_ADDRESS_MODE.ZIP_CODE;
			var isGMapWithZipCodeProvider =
				Config.retailer.settings.autocompleteAddressField &&
				Config.retailer.settings.activeZipProvider &&
				Config.retailer.settings.activeZipProvider.name === 'Get Address';

			var isEnable = Config.retailer.settings.isAddressVerificationEnabled === 'true';
			var isUseGoogleMapApi = [SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON, SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS].includes(
				Config.retailer.deliveryAreaMethod
			);
			var isAddressVerificationEnabled = isEnable && isUseGoogleMapApi;
			var addressFormSettingsV3 = Util.tryParseJson(Config.retailer.settings.addressFormSettingsV3 || '{}');
			var addressFormSeparateStreetHouse = Config.retailer.settings.addressFormSeparateStreetHouse === 'true';
			var addressFormFieldLabels = Util.tryParseJson(Config.retailer.settings.addressFormFieldLabels || '{}');
			var isUseNewAddressesFeature = Config.retailer.settings.isUseNewAddressesFeature === 'true';
			var retailerCurrencySymbol = Config.retailer.currencySymbol;
			var dropPinClarifyMessage = Util.tryParseJson(Config.retailer.settings.dropPinClarifyMessage || '{}');

			var _dropPinDisableFields = {
				city: true,
				text1: true,
				zipCode: true,
				state: true,
				street: true,
				houseNumber: true
			};

			var _addressFormFields = {
				city: 'city',
				address: 'address',
				zipCode: 'zipCode',
				entrance: 'entrance',
				apartment: 'apartment',
				buildingCode: 'buildingCode',
				state: 'state',
				comments: 'comments',
				street: 'street',
				houseNumber: 'houseNumber',
				floor: 'floor'
			};

			var _addressFieldsMapping = {
				city: 'city',
				address: 'text1',
				zipCode: 'zipCode',
				entrance: 'entry',
				apartment: 'apartment',
				buildingCode: 'buildingCode',
				state: 'state',
				comments: 'text2',
				street: 'street',
				houseNumber: 'houseNumber',
				floor: 'floor'
			}

			var _ADDRESS_TYPE_MAP = {
				city: 'city',
				text1: 'address',
				street: 'address',
				zipCode: 'zipCode'
			};

			var _addressComponents = ['city', 'street', 'houseNumber', 'text1', 'zipCode'];

			var _DEFAULT_ERROR_MESSAGE = {
				city: 'Sorry, Your city was not found. Please select an address from auto-complete suggestions or pin your address using the google maps option.',
				address:
					'Sorry, Your address was not found. Please select an address from auto-complete suggestions or pin your address using the google maps option.',
				zipCode:
					'Sorry, Your zip code was not found. Please select an address from auto-complete suggestions or pin your address using the Google Maps option.'
			};

			var _DEFAULT_ERROR_MESSAGE_NON_DROP_PIN = {
				city: 'autocomplete_city_not_found_non_droppin',
				address: 'autocomplete_address_not_found_non_droppin',
				zipCode: 'autocomplete_zip_code_not_found_non_droppin'
			};

			addressFormService.extractAddressField = extractAddressField;
			addressFormService.cancelPinnedAddress = cancelPinnedAddress;
			addressFormService.onAddressChosen = onAddressChosen;
			addressFormService.onDroppedPinAddress = onDroppedPinAddress;
			addressFormService.getAddressFormFieldSettings = getAddressFormFieldSettings;
			addressFormService.getAddressFieldLabel = getAddressFieldLabel;
			addressFormService.disableAllDropPinFields = disableAllDropPinFields;
			addressFormService.getDropPinDisableFields = getDropPinDisableFields;
			addressFormService.isShowAddressField = isShowAddressField;
			addressFormService.isDisableAddressField = isDisableAddressField;
			addressFormService.getDefaultLocation = getDefaultLocation;
			addressFormService.isDropPinRequiredStreetAndHouseNumber = isDropPinRequiredStreetAndHouseNumber;
			addressFormService.getFormFieldErrorMessage = getFormFieldErrorMessage;
			addressFormService.isExistedInSuggestions = isExistedInSuggestions;
			addressFormService.verifyIsSuggestedValue = verifyIsSuggestedValue;
			addressFormService.isLocationChanged = isLocationChanged;
			addressFormService.handleOnLocationBlur = handleOnLocationBlur;
			addressFormService.onAddressBlur = onAddressBlur;
			addressFormService.setOrInitValueForAddressField = setOrInitValueForAddressField;
			addressFormService.getCheckoutAddress = getCheckoutAddress;
			addressFormService.cleanAddressDataBaseOnRetailerConfig = cleanAddressDataBaseOnRetailerConfig;
			addressFormService.transformAddress = transformAddress;
			addressFormService.getDropPinClarifyMessage = getDropPinClarifyMessage;
			addressFormService.initAddressFormService = initAddressFormService;
			addressFormService.isNullOrEmpty = isNullOrEmpty;
			addressFormService.extractAddressDetails = extractAddressDetails;
			addressFormService.isAddressEnoughFieldsToGetTimes = isAddressEnoughFieldsToGetTimes;
			addressFormService.addressFormSeparateStreetHouse = addressFormSeparateStreetHouse;
			addressFormService.isAddressFilteringCityMode = isAddressFilteringCityMode;
			addressFormService.isAddressFilteringZipCodeMode = isAddressFilteringZipCodeMode;
			addressFormService.isUseGoogleMapApi = isUseGoogleMapApi;
			addressFormService.isAddressVerificationEnabled = isAddressVerificationEnabled;
			addressFormService.isUseNewAddressesFeature = isUseNewAddressesFeature;
			addressFormService.enableAddressFiltering = enableAddressFiltering;
			addressFormService.isGoogleMapDropPinAllow = isGoogleMapDropPinAllow;
			addressFormService.addressFiltering = addressFiltering;
			addressFormService.isGoogleMapDropPinValidateHouseNumAndStreet = isGoogleMapDropPinValidateHouseNumAndStreet;
			addressFormService.isAddressFormSeparateStreetHouse = isUseNewAddressesFeature && isAddressFilteringCityMode && addressFormSeparateStreetHouse;

			function extractAddressField(field, addressData) {
				var value = addressData && addressData[field];
				if (value === null || value === undefined) return null;
				if (typeof value === 'string') return value.trim();
				if (typeof value === 'number' || typeof value === 'boolean') return value;
				return null;
			}

			function setOrInitValueForAddressField(addressData, field, value, initialValue) {
				var isDefined = angular.isDefined(addressData[field]);
				addressData[field] = isDefined ? value : initialValue;
			}

			function cancelPinnedAddress(addressData) {
				setOrInitValueForAddressField(addressData, 'zipCode', '', '');
				setOrInitValueForAddressField(addressData, 'text1', '', '');
				setOrInitValueForAddressField(addressData, 'city', '', '');
				setOrInitValueForAddressField(addressData, 'street', '', '');
				setOrInitValueForAddressField(addressData, 'houseNumber', '', '');
				setOrInitValueForAddressField(addressData, 'state', '', '');
			}

			function _parseStringToNumber(str) {
				var number;
				if (/^\d+$/.test(str)) {
					number = parseInt(str, 10);
				}
				return number || null;
			}

			function onAddressChosen(placeId, languageId) {
				return GoogleMapService.reverseGeocode({placeId: placeId, languageId: languageId}).then(function (_gAddress) {
					return extractAddressDetails(_gAddress);
				});
			}

			function extractAddressDetails(addressDetails) {
				var extractedInfo = GoogleMapService.extractInfoFromAddressComponents(addressDetails.address_components);
				var text1Obj = GoogleMapService.constructText1(
					extractedInfo.countryCode,
					extractedInfo.houseNumber,
					extractedInfo.route,
					extractedInfo.city
				);

				var _houseNumber = _parseStringToNumber(extractedInfo.houseNumber);
				var _address = {
					text1: text1Obj.value,
					city: extractedInfo.city,
					country: extractedInfo.country,
					countryCode: extractedInfo.countryCode,
					zipCode: extractedInfo.zipCode,
					state: extractedInfo.state,
					street: extractedInfo.route,
					houseNumber: _houseNumber,
					lng: addressDetails.geometry.location.lng(),
					lat: addressDetails.geometry.location.lat(),
					externalPlaceId: addressDetails.place_id
				};

				cleanAddressDataBaseOnRetailerConfig(_address);

				if (isAddressFilteringCityMode) {
					delete _address.city;
				} else if (isAddressFilteringZipCodeMode) {
					delete _address.zipCode;
				}

				return _address;
			}

			function onDroppedPinAddress(selectedAddress) {
				if (!selectedAddress) {
					return;
				}

				selectedAddress.houseNumber = _parseStringToNumber(selectedAddress.houseNumber);
				var _address = {
					text1: selectedAddress.text1,
					city: selectedAddress.city,
					country: selectedAddress.country,
					countryCode: selectedAddress.countryCode,
					zipCode: selectedAddress.zipCode,
					state: selectedAddress.state,
					lat: selectedAddress.lat,
					lng: selectedAddress.lng,
					street: selectedAddress.street,
					houseNumber: selectedAddress.houseNumber,
					externalPlaceId: null
				};

				cleanAddressDataBaseOnRetailerConfig(_address);
				return _address;
			}

			function getAddressFormFieldSettings(fieldName) {
				var _clonedFormSettings = angular.copy(addressFormSettingsV3, {});

				var _fieldSettings = _clonedFormSettings[fieldName];
				if (!_fieldSettings) return {};

				return _fieldSettings;
			}

			function getAddressFieldLabel(fieldName, languageId, options) {
				var paths = [];
				var _clonedFormFieldLabels = angular.copy(addressFormFieldLabels, {});
				var _formFieldSettings = getAddressFormFieldSettings(fieldName);
				var _options = options || {};

				if (_clonedFormFieldLabels[fieldName] && _clonedFormFieldLabels[fieldName][languageId]) {
					paths.push(_clonedFormFieldLabels[fieldName][languageId]);
				} else if (_formFieldSettings.label) {
					paths.push(_translate('address_form_field_label_' + _formFieldSettings.label));
				}

				if(!_options.ignoreMandatory) {
					paths.push(getAddressFormFieldSettings(fieldName).isMandatory ? '*' : '');
				}

				return paths.join(' ');
			}

			function disableAllDropPinFields(dropPinDisabledFields) {
				for (var fieldName in dropPinDisabledFields) {
					dropPinDisabledFields[fieldName] = true;
				}
			}

			function getDropPinDisableFields() {
				return angular.copy(_dropPinDisableFields);
			}

			function isJustDroppedNotDetectedAddress(isDropPinAddress, isDropPinAddressNotDetected) {
				// address just dropped pin - not the address from previous order
				return isDropPinAddress && isDropPinAddressNotDetected;
			}

			function isShowAddressField(fieldName, isDropPinAddress, isDropPinAddressNotDetected) {
				var _isAddressFieldEnable = getAddressFormFieldSettings(fieldName).isEnabled;
				if (!_isAddressFieldEnable) return false;

				if (!isGoogleMapDropPinValidateHouseNumAndStreet) return true;

				return !isJustDroppedNotDetectedAddress(isDropPinAddress, isDropPinAddressNotDetected);
			}

			function isDropPinRequiredStreetAndHouseNumber(isDropPinAddress, isDropPinAddressNotDetected) {
				if (!isGoogleMapDropPinValidateHouseNumAndStreet) return false;

				// DROP PIN
				return isJustDroppedNotDetectedAddress(isDropPinAddress, isDropPinAddressNotDetected);
			}

			function isDisableAddressField(filteringMode, addressData) {
				// only work when isAddressVerificationEnabled ON
				if (!isAddressVerificationEnabled) return false;

				// in CITY mode address field will disable when city field is empty
				if (
					filteringMode === FILTER_ADDRESS_MODE.CITY &&
					isAddressFilteringCityMode &&
					!extractAddressField(_addressFormFields.city, addressData)
				) {
					return true;
				}

				// in ZIP_CODE mode address field will disable when city field is empty
				if (
					filteringMode === FILTER_ADDRESS_MODE.ZIP_CODE &&
					isAddressFilteringZipCodeMode &&
					!extractAddressField(_addressFormFields.zipCode, addressData)
				) {
					return true;
				}

				return false;
			}

			function getDefaultLocation(addressData) {
				var _defaultLocation;
				if (enableAddressFiltering) {
					switch (addressFiltering) {
						case FILTER_ADDRESS_MODE.ZIP_CODE: {
							_defaultLocation = extractAddressField('zipCode', addressData);
							break;
						}
						case FILTER_ADDRESS_MODE.CITY: {
							_defaultLocation = extractAddressField('city', addressData);
							break;
						}
					}
				}

				return _defaultLocation;
			}

			function getFormFieldErrorMessage(fieldName) {
				var message;

				var addressType = _ADDRESS_TYPE_MAP[fieldName];
				var addressErrorMap;
				if (isGoogleMapDropPinAllow) {
					message = _DEFAULT_ERROR_MESSAGE[addressType];
					addressErrorMap = _addressVerificationText[addressType];
					if (addressErrorMap && addressErrorMap[Config.language.culture]) {
						message = addressErrorMap[Config.language.culture];
					}
				} else {
					message = _DEFAULT_ERROR_MESSAGE_NON_DROP_PIN[addressType];
					addressErrorMap = _addressVerificationTextDropPinOff && _addressVerificationTextDropPinOff[addressType];
					if (addressErrorMap && addressErrorMap[Config.language.culture]) {
						message = addressErrorMap[Config.language.culture];
					}
				}

				// Emit ECOM-17455 Address Form Error Displayed event
				if (message && fieldName) {
					$rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
						fieldWithError: fieldName,
						errorType: "Not found!"
					});
				}

				return message;
			}

			function _isAddrSuggestionValid(placeTypes) {
				var isValidPlaceType = [GOOGLE_MAP_ADDRESS_TYPES.ROUTE].some(function (type) {
					return placeTypes.includes(type);
				});
				return isValidPlaceType;
			}

			function isExistedInSuggestions(addressData, addressType, value, suggestions) {
				var _address = addressData || {};
				var hasCoordinatesOrPlaceId = (_address.lat && _address.lng) || _address.externalPlaceId;
				if (!value || hasCoordinatesOrPlaceId || _address.isVerified) {
					return true;
				}

				if (!suggestions || !suggestions.length) return false;

				for (var idx = 0; idx < suggestions.length; idx++) {
					var item = suggestions[idx];
					switch (addressType) {
						case _ADDRESS_TYPE_MAP.city: {
							if (item.mainValue && item.mainValue.toLowerCase() === value.toLowerCase()) {
								return true;
							}
						}
						case _ADDRESS_TYPE_MAP.text1:
						case _ADDRESS_TYPE_MAP.street: {
							var isValid = _isAddrSuggestionValid(item.placeTypes);
							var isExisted = item.mainValue && item.mainValue.toLowerCase() === value.toLowerCase();
							if (isValid && isExisted) {
								return true;
							}
						}
						case _ADDRESS_TYPE_MAP.zipCode: {
							if (item.mainValue && item.mainValue.toLowerCase().replace(/\s+/g, '') === value.toLowerCase().replace(/\s+/g, '')) {
								return true;
							}
						}
					}
				}
				return false;
			}

			function verifyIsSuggestedValue(addressData, isDropPinAddress, suggestedAddresses, suggestedCities, suggestedZipCodes) {
				var city = extractAddressField('city', addressData);
				var text1 = extractAddressField('text1', addressData);
				var street = extractAddressField('street', addressData);
				var zipCode = extractAddressField('zipCode', addressData);

				var addressText1 = text1 && city ? text1 + ', ' + city : text1;
				var addressStreet = street && city ? street + ', ' + city : street;
				var verifyAddressObj = {};

				if (isUseNewAddressesFeature && !isGMapWithZipCodeProvider) {
					if (isDropPinAddress) return {};

					if (getAddressFormFieldSettings(_addressFormFields.address).isEnabled) {
						verifyAddressObj.text1 = isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.text1, addressText1, suggestedAddresses);
					}

					if (getAddressFormFieldSettings(_addressFormFields.street).isEnabled) {
						verifyAddressObj.street = isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.street, addressStreet, suggestedAddresses);
					}

					if (getAddressFormFieldSettings(_addressFormFields.city).isEnabled) {
						verifyAddressObj.city = isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.city, city, suggestedCities);
					}

					if (isAddressFilteringZipCodeMode) {
						verifyAddressObj.zipCode = isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.zipCode, zipCode, suggestedZipCodes);
					}
				} else {
					verifyAddressObj = {
						city: isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.city, city, suggestedCities),
						text1: isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.text1, addressText1, suggestedAddresses)
					};
				}

				return verifyAddressObj;
			}

			function isLocationChanged(field, backupAddress, addressData) {
				if (!backupAddress || !backupAddress[field] || !addressData || !addressData[field]) {
					return true;
				}

				var prev = backupAddress[field];
				var curr = addressData[field];

				if (typeof prev === 'number' || typeof curr === 'number') {
					return Number(prev) !== Number(curr);
				}

				return prev.trim().toLowerCase() !== curr.trim().toLowerCase();
			}

			function _isPreviousAddress(currAddr, prevAddr) {
				if (!prevAddr) return false;

				return _addressComponents.every(function (field) {
					if (!prevAddr[field]) prevAddr[field] = '';
					if (!currAddr[field]) currAddr[field] = '';

					var prev = prevAddr[field];
					var curr = currAddr[field];

					if (typeof prev === 'number' || typeof curr === 'number') {
						return Number(prev) === Number(curr);
					}

					return prev.trim().toLowerCase() === curr.trim().toLowerCase();
				});
			}

			function handleOnLocationBlur(emittedField, backupAddress, addressData, previousAddress) {
				var isFieldChanged = isLocationChanged(emittedField, backupAddress, addressData);
				if (isFieldChanged) {
					var clearingFields = {
						externalPlaceId: null,
						lat: null,
						lng: null,
						hasHouseNumberAndRoute: true,
						isShowEditAddress: false,
						isDisabledAddressField: false,
						isVerified: false
					};

					angular.extend(addressData, clearingFields);
					angular.extend(backupAddress, addressData);
				}

				var isPrevAddr = _isPreviousAddress(addressData, previousAddress);
				if (isPrevAddr && isAddressVerificationEnabled) {
					var _currentAddress = addressData;
					var _hasCoordinatesOrPlaceId = (_currentAddress.lat && _currentAddress.lng) || _currentAddress.externalPlaceId;
					if (_hasCoordinatesOrPlaceId) return;

					var _address = previousAddress;
					angular.extend(addressData, {
						externalPlaceId: _address.externalPlaceId,
						lat: _address.lat,
						lng: _address.lng,
						isVerified: _address.isVerified
					});
				}
			}

			function onAddressBlur(fieldName, backupAddress, addressData, suggestedAddresses) {
				var _isAddressChanged = isLocationChanged(fieldName, backupAddress, addressData);
				if (_isAddressChanged) {
					cleanAddressDataBaseOnRetailerConfig(addressData);
				}

				var _addressText = extractAddressField(fieldName, addressData);
				if (!_addressText || !isAddressVerificationEnabled) return;

				var city = extractAddressField('city', addressData);
				if (city) {
					var address = _addressText + ', ' + city;
					var isExisted = isExistedInSuggestions(addressData, _ADDRESS_TYPE_MAP.text1, address, suggestedAddresses);

					if (!isExisted) return {isValid: false};
					return {isValid: true};
				}

				var suggestion = findSuggestion(_addressText, suggestedAddresses);
				if (suggestion) return {isValid: true, suggestion: suggestion};

				return {isValid: false};
			}

			function findSuggestion(addressText, suggestions) {
				var suggestion = suggestions.find(function (item) {
					return item.mainValue && item.mainValue.toLowerCase() === addressText.toLowerCase();
				});
	
				return suggestion;
			}

			function cleanAddressDataBaseOnRetailerConfig(addressData) {
				if (!addressData) return;

				if (!isUseGoogleMapApi) {
					// deliveryAreaMethod === ZIP_CODE
					var transformedAddress = transformAddress('separate', addressData);
					angular.extend(addressData, transformedAddress);
					return;
				}

				if (isUseNewAddressesFeature && isAddressFilteringCityMode && addressFormSeparateStreetHouse && getAddressFormFieldSettings(_addressFormFields.street).isEnabled) {
					var transformedAddress = transformAddress('separate', addressData);
					angular.extend(addressData, transformedAddress);
					_clearNotEnabledData(addressData);
					return;
				}

				var transformedAddress = transformAddress('merge', addressData);
				angular.extend(addressData, transformedAddress);
				_clearNotEnabledData(addressData);
			}

			function _clearNotEnabledData(addressData) {
				if (!isUseNewAddressesFeature) return;
	
				for (var fieldname in addressFormSettingsV3) {
					if(addressFormSettingsV3[fieldname] && addressFormSettingsV3[fieldname].isEnabled) continue;
					var addressField = _addressFieldsMapping[fieldname];
					if(!addressField) continue;
					addressData[addressField] = null;
					delete addressData[fieldname];
				}
			}

			function _extractAddressTextInfo(addressText) {
				var tokens = addressText.trim().split(/\s+/);
				var firstNumber = null;
				var lastNumber = null;

				var startIndex = 0;
				var endIndex = tokens.length - 1;

				if (/^\d+$/.test(tokens[0])) {
					firstNumber = parseInt(tokens[0], 10);
					startIndex = 1;
				}

				if (/^\d+$/.test(tokens[tokens.length - 1])) {
					lastNumber = parseInt(tokens[tokens.length - 1], 10);
					endIndex = tokens.length - 2;
				}

				var restTokens = tokens.slice(startIndex, endIndex + 1);
				var street = restTokens.join(' ');

				if (retailerCurrencySymbol === '₪') {
					return {
						houseNumber: lastNumber,
						street: street
					};
				}

				return {
					houseNumber: firstNumber,
					street: street
				};
			}

			function transformAddress(action, addressData) {
				var _address = angular.copy(addressData, {});
				var text1 = extractAddressField('text1', _address);
				var street = extractAddressField('street', _address);
				var houseNumber = extractAddressField('houseNumber', _address);

				var _baseResult = {
					text1: null,
					street: null,
					houseNumber: null
				};

				switch (action) {
					case 'merge': {
						if (text1) {
							_baseResult.text1 = text1;
							return _baseResult;
						}

						if (!street) return _baseResult;

						if (retailerCurrencySymbol === '₪') {
							_baseResult.text1 = street + (houseNumber ? ' ' + houseNumber : '');
							return _baseResult;
						}

						_baseResult.text1 = houseNumber + (street ? ' ' + street : '');
						return _baseResult;
					}
					case 'separate': {
						if (street) {
							_baseResult.street = street;
							_baseResult.houseNumber = houseNumber;
							return _baseResult;
						}

						if (!text1) {
							return _baseResult;
						}

						var addressTextInfo = _extractAddressTextInfo(text1);
						_baseResult.houseNumber = addressTextInfo.houseNumber;
						_baseResult.street = addressTextInfo.street;
						return _baseResult;
					}
				}
			}

			function getCheckoutAddress(addressData) {
				if (!addressData) {
					return {};
				}
				var _address = {
					id: addressData.id,
					text1: addressData.text1,
					text2: addressData.text2,
					country: addressData.country,
					countryCode: addressData.countryCode,
					street: addressData.street,
					houseNumber: addressData.houseNumber,
					entry: addressData.entry,
					floor: addressData.floor,
					apartment: addressData.apartment,
					city: addressData.city,
					zipCode: addressData.zipCode,
					state: addressData.state,
					buildingCode: addressData.buildingCode,
					friendlyName: addressData.friendlyName,
					lat: addressData.lat,
					lng: addressData.lng,
					externalPlaceId: addressData.externalPlaceId || null
				};
	
				cleanAddressDataBaseOnRetailerConfig(_address);
				return _address;
			}

			function getDropPinClarifyMessage(languageCode) {
				var message = dropPinClarifyMessage[languageCode];
				if (message) return message;
	
				return _translate('address_drop_pin_clarify_default_message');
			}

			// prevent case false (boolean)
			function isNullOrEmpty(value) {
				if (value === null || value === undefined || value === '') {
					return true;
				}

				if (typeof value === 'string' && value.trim() === '') {
					return true;
				}

				return false;
			}

			function isAddressEnoughFieldsToGetTimes(addressDetails){                
				var citySetting = getAddressFormFieldSettings('city')
				var addressSetting = getAddressFormFieldSettings('address')
				var zipCodeSetting = getAddressFormFieldSettings('zipCode')
				var stateSetting = getAddressFormFieldSettings('state')
				var streetSetting = getAddressFormFieldSettings('street')
				var houseNumberSetting = getAddressFormFieldSettings('houseNumber')
				
				var city = extractAddressField('city', addressDetails);
				var text1 = extractAddressField('text1', addressDetails);
				var zipCode = extractAddressField('zipCode', addressDetails);
				var state = extractAddressField('state', addressDetails);
				var street = extractAddressField('street', addressDetails);
				var houseNumber = extractAddressField('houseNumber', addressDetails);
	
				if(citySetting.isEnabled && citySetting.isMandatory && isNullOrEmpty(city)) return false;
				if(addressSetting.isEnabled && addressSetting.isMandatory && isNullOrEmpty(text1)) return false;
				if(zipCodeSetting.isEnabled && zipCodeSetting.isMandatory && isNullOrEmpty(zipCode)) return false;
				if(stateSetting.isEnabled && stateSetting.isMandatory && isNullOrEmpty(state)) return false;
				if(streetSetting.isEnabled && streetSetting.isMandatory && isNullOrEmpty(street)) return false;
				if(houseNumberSetting.isEnabled && houseNumberSetting.isMandatory && isNullOrEmpty(houseNumber)) return false;
					
				return true
			}

			function initAddressFormService() {
				if(!isUseNewAddressesFeature || !isUseGoogleMapApi) {
					return addressFormService;
				}

				if (!isNullOrEmpty(addressFormSettingsV3) && !isNullOrEmpty(enableAddressFiltering) && !isNullOrEmpty(addressFiltering)) {
					return addressFormService;
				}

				return AddressService.getAddressFormSettings().then(function (formSettings) {
					addressFormSettingsV3 = formSettings.settings;
					enableAddressFiltering = !!formSettings.mode;
					addressFiltering = formSettings.mode;
					isAddressFilteringCityMode = enableAddressFiltering && addressFiltering === FILTER_ADDRESS_MODE.CITY;
					isAddressFilteringZipCodeMode = enableAddressFiltering && addressFiltering === FILTER_ADDRESS_MODE.ZIP_CODE;

					addressFormService.enableAddressFiltering = enableAddressFiltering;
					addressFormService.isAddressFilteringCityMode = isAddressFilteringCityMode;
					addressFormService.isAddressFilteringZipCodeMode = isAddressFilteringZipCodeMode;

					return addressFormService;
				});
			}

		}
	]);
})(angular, app);
